import { Button, CircularProgress } from "@mui/material";
import type { ButtonProps } from "@mui/material";
import { useTranslation } from "shared/hooks/useTranslation";
import { UX_LOADING } from "lib/uxTokens";

interface SubmitButtonProps extends ButtonProps {
    loading?: boolean;
    loadingLabel?: string;
}

export default function SubmitButton({
    loading = false,
    loadingLabel,
    disabled,
    startIcon,
    children,
    ...rest
}: SubmitButtonProps) {
    const { t } = useTranslation();

    return (
        <Button
            disabled={loading || disabled}
            startIcon={loading ? <CircularProgress size={UX_LOADING.inlineSpinnerSize} /> : startIcon}
            {...rest}
        >
            {loading ? (loadingLabel ?? t("common.loading")) : children}
        </Button>
    );
}
